import * as React from 'react'

import { Box, Card, Icon, Tag } from '@factorialco/deprecated-design-system'
import { AnimatePresence, motion } from 'framer-motion'

import i18n from 'modules/core/lib/i18n'

import type { Settings } from 'modules/settings/lib/settings'

import Title from './Title'

interface SectionProps {
  settings?: Settings
}
const Section = ({ settings }: SectionProps) => {
  const visibleSettings = settings?.children.filter(
    (child) => ('hidden' in child && !child.hidden) || !('hidden' in child)
  )
  if (!visibleSettings?.length || !settings) return null

  return (
    <Box width="full" gap="s24" paddingX="s48" paddingY="s32">
      <Title title={settings.title} icon={settings.icon} />
      <Box
        width="full"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(330px, 1fr))',
        }}
        gap="s24"
      >
        {visibleSettings.map((setting) => (
          <AnimatePresence key={setting.id}>
            <motion.div
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              layout
              data-intercom-target={`settings-${setting.id}`}
            >
              <Card to={setting.url}>
                <Card.Eyebrow>
                  <Icon.Large icon={setting.icon} color="radicalRed1000" />
                </Card.Eyebrow>
                <Card.Title>{setting.title}</Card.Title>
                <Card.Description>{setting.description}</Card.Description>
                <Card.Content>
                  {'missingInfo' in setting && setting.missingInfo && (
                    <Tag>{i18n.t('common.information_missing')}</Tag>
                  )}
                </Card.Content>
              </Card>
            </motion.div>
          </AnimatePresence>
        ))}
      </Box>
    </Box>
  )
}

export default Section
